'use strict';

export class Pager {
    public page:number;
    public totalItems:number;
    public pageSize:number;
    public pagingCookie:string;

    constructor(pageSize) {
        this.page = 1;
        this.totalItems = 0;
        this.pageSize = pageSize;
        this.pagingCookie = null; // CRM search specific
    }

    getPages = function () {
        var pages = [];
        var max = this.getLast();
        for (var i = 1; i <= max; i++) {
            pages.push(i);
        }
        return pages;
    };

    isLastPage = function () {
        return this.page * this.pageSize >= this.totalItems;
    };

    isFirstPage = function () {
        return this.page == 1;
    };

    getFrom = function () {
        return this.totalItems ? 1 + (this.page - 1) * this.pageSize : 0;
    };

    getTo = function () {
        var to = this.page * this.pageSize;
        if (to > this.totalItems) {
            return this.totalItems;
        }
        return to;
    };

    getLast = function () {
        return Math.ceil(this.totalItems / this.pageSize);
    };

    reset = function () {
        this.page = 1;
        this.totalItems = 0;
    };
}


export class PagerFactory {
    createPager(pageSize):Pager {
        return new Pager(pageSize);
    }
}

export default PagerFactory;


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/widget/table/pager.model.ts